<div class="history-body">
  <div *ngIf="event.callDirection" class="history-body-row">
    <div class="history-body-row-label"><span>{{ 'RECORDS_LIST.CALL_TYPE' | translate}}</span>:</div>
    <div class="history-body-row-value  ">{{'DIRECTION.' + event.callDirection | translate}}</div>
  </div>
  <div *ngIf="event.callLength" class="history-body-row">
    <div class="history-body-row-label">{{'RECORDS_LIST.CALL_LENGTH' | translate}}</div>
    <div class="history-body-row-value  ">{{parsedTime}}</div>
  </div>

  <div *ngFor="let row of changelogData">
    <div *ngIf="row.oldValue || row.newValue" class="history-body-row history-body-changelog-row">
      <!-- default tag's oldValue is ',,' -->
      <div *ngIf="row.oldValue != ',,'" class="history-body-row-label">{{ getContactDetails(row.key) | translate }}</div>
      <div *ngIf="row.oldValue && row.newValue" [class.external-link-row] = "row.key === 'externalLink'" class="history-body-row-value history-body-change-value">
        <div class="history-body-old-value">{{row.oldValue}}<i class="material-icons">trending_flat</i></div>
        <div class="history-body-new-value">{{row.newValue}}</div>
      </div>
      <div *ngIf="row.oldValue != ',,' && !row.newValue" class="history-body-row-value history-body-change-value">
        <div class="history-body-old-value">{{row.oldValue}}<i class="material-icons">trending_flat</i></div>
        <div class="history-body-new-value"> - </div>
      </div>
      <div *ngIf="!row.oldValue" class="history-body-row-value history-body-change-value">
        <div class="history-body-new-value">{{row.newValue}}</div>
      </div>
    </div>
  </div>

  <div *ngIf="event.clientMsisdn" class="history-body-row">
    <div class="history-body-row-label">{{'RECORDS_LIST.CLIENT_NUMBER' | translate}}</div>
    <div class="history-body-row-value">
      <span *ngIf="getIsoCountry(event.clientMsisdn)"
            class="flag-icon flag-icon-{{getIsoCountry(event.clientMsisdn)}} m-r-sm shadow-up"></span>
      <span>{{event.clientMsisdn | phoneNumber}}</span>
    </div>
  </div>
  <div *ngIf="event.surname && event.name" class="history-body-row">
    <div class="history-body-row-label">{{'RECORDS_LIST.USER' | translate}}</div>
    <div class="history-body-row-value">{{getUserFullName()}}</div>
  </div>
  <div *ngIf="getCallingMode(event)" class="history-body-row">
    <div class="history-body-row-label">{{'EVENT_DETAILS.CALL_MODE' | translate}}</div>
    <div class="history-body-row-value">{{ getCallingMode(event) | translate }}</div>
  </div>
  <div *ngIf="event.newMsisdn" class="history-body-row">
    <div class="history-body-row-label"><span>{{ getNewMsisdnTranslation() | translate}}</span></div>
    <div class="history-body-row-value">
      <span *ngIf="getIsoCountry(event.newMsisdn)"
            class="flag-icon flag-icon-{{getIsoCountry(event.newMsisdn)}} m-r-sm shadow-up"></span>
      <span>{{event.newMsisdn | phoneNumber}}</span>
    </div>
  </div>
  <div *ngIf="event.oldMsisdn" class="history-body-row">
    <div class="history-body-row-label">{{'RECORDS_LIST.OLD_MSISDN' | translate}}</div>
    <div class="history-body-row-value">
       <span *ngIf="getIsoCountry(event.oldMsisdn)"
             class="flag-icon flag-icon-{{getIsoCountry(event.oldMsisdn)}} m-r-sm shadow-up"></span>
      <span>{{event.oldMsisdn | phoneNumber}}</span>
    </div>
  </div>
  <div *ngIf="event.note" class="history-body-row">
    <div class="history-body-row-label">{{'RECORDS_LIST.NOTE' | translate}}</div>
    <div class="history-body-row-value history-note">{{event.note}}</div>
  </div>
</div>
<cc-file-drop-player
  *ngIf="event.recordingAvailable"
  [voiceMailFileName]="getFileName()"
  [url]="getRecordingUrl()"
></cc-file-drop-player>
<!--<div *ngIf="!event.recordingAvailable"></div>-->
